<template>
    <b-row>
        <b-col>
            <b-form-group
                label="Части речи"
                label-for="GrammSpeechParts"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammSpeechParts" 
                        v-model="filter.gr.partOfSpeech" 
                        :options="partOfSpeech"/>
            </b-form-group>
        </b-col>
        <b-col>
            <b-form-group
                label="Род"
                label-for="GrammGenus"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammGenus" 
                        v-model="filter.gr.genus" 
                        :options="genus"/>
            </b-form-group>
            
            <hr/>

            <b-form-group
                label="Одушевленность"
                label-for="GrammAnimacy"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammAnimacy" 
                        v-model="filter.gr.animacy" 
                        :options="animacy"/>
            </b-form-group>

        </b-col>
        
        <b-col>

            <b-form-group
                label="Число"
                label-for="GrammNumber"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammNumber" 
                        v-model="filter.gr.number" 
                        :options="number"/>
            </b-form-group>

            <hr/>

            <b-form-group
                label="Краткая/полная форма"
                label-for="GrammShortLongForm"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammShortLongForm" 
                        v-model="filter.gr.shortLongForm" 
                        :options="shortLongForm"/>
            </b-form-group>
        </b-col>

        <b-col>
            <b-form-group
                label="Падеж"
                label-for="GrammCoreCases"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammCoreCases" 
                        v-model="filter.gr.coreCases" 
                        :options="coreCases"/>
            </b-form-group>

        </b-col>

        <b-col>

            <b-form-group
                label="Степень сравнения"
                label-for="GrammDegreeOfComparison"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammDegreeOfComparison" 
                        v-model="filter.gr.degreeOfComparison" 
                        :options="degreeOfComparison"/>
            </b-form-group>

            <hr/>

            <b-form-group
                label="Вид"
                label-for="GrammView"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammView" 
                        v-model="filter.gr.view" 
                        :options="view"/>
            </b-form-group>

            
        </b-col>

        <b-col>

            <b-form-group
                label="Переходность"
                label-for="GrammTransitivity"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammTransitivity" 
                        v-model="filter.gr.transitivity" 
                        :options="transitivity"/>
            </b-form-group>

            <hr/>

            <b-form-group
                label="Залог"
                label-for="GrammPledge"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammPledge" 
                        v-model="filter.gr.pledge" 
                        :options="pledge"/>
            </b-form-group>

        </b-col>

        <b-col>

            <b-form-group
                label="Форма (репрезентация) глагола"
                label-for="GrammFormOfVerb"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammFormOfVerb" 
                        v-model="filter.gr.formOfVerb" 
                        :options="formOfVerb"/>
            </b-form-group>

            <hr/>

            <b-form-group
                label="Наклонение"
                label-for="GrammMood"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammMood" 
                        v-model="filter.gr.mood" 
                        :options="mood"/>
            </b-form-group>

        </b-col>

        <b-col>

            <b-form-group
                label="Время"
                label-for="GrammTime"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammTime" 
                        v-model="filter.gr.time" 
                        :options="time"/>
            </b-form-group>

            <hr/>

            <b-form-group
                label="Лицо"
                label-for="GrammFace"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammFace" 
                        v-model="filter.gr.face" 
                        :options="face"/>
            </b-form-group>

        </b-col>

        <b-col>

            <b-form-group
                label="Прочие признаки"
                label-for="GrammOtherSigns"
                horizontal>
                    <b-form-checkbox-group 
                        stacked 
                        buttons 
                        id="GrammOtherSigns" 
                        v-model="filter.gr.otherSigns" 
                        :options="otherSigns"/>
            </b-form-group>

        </b-col>

    </b-row>
</template>

<script>
export default {
    name: "udmgrammar",

    props: {
        filter: {
            type: Object,
            default: null
        }
    },

    data(){
        return {
            partOfSpeech: ['S','A','NUM','ANUM','V','ADV','PRAEDIC','PARENTH','SPRO','APRO','ADVPRO','PRAEDICPRO','PR','CONJ','PART','INTJ','INIT','NONLEX'],
            genus: ['m','f','m-f','n'],
            animacy: ['anim','inan'],
            number: ['sg','pl'],
            coreCases: ['nom','acc','gen','abl','dat','ins','car','adv'],
            shortLongForm: ['brev','plen'],
            degreeOfComparison: ['comp','comp2','supr'],
            view: ['pf','ipf'],
            transitivity: ['intr','tran'],
            pledge: ['act','pass','med'],
            formOfVerb: ['inf','partcp','ger'],
            mood: ['indic','imper','imper2'],
            time: ['praet','praes','fut'],
            face: ['1p','2p','3p'],
            otherSigns: ['persn','patrn','famn','zoon','0']
        }
    }
}
</script>